import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const PDIExcelCikis = () => {
    return (
        <div>
            <ExcelUpload
                requiredColumnsSase={["sase", "pdi_exit_date"]}
                process_type="PDI_EXIT"
                ExcelName={"PDI Çıkış Hatalı Şaseler"}
                Title={"PDI Çıkış"}
                exampleData={[
                    { sase: "VF3YEF6F0RMA03711", pdi_exit_date: "01.01.2025" },
                ]}
                role_name={"pdiexcel_cikis_read"}
            />
        </div>
    )
}

export default PDIExcelCikis